import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faRobot, faPlus } from '@fortawesome/free-solid-svg-icons';

const AutomaticMessagesHeader = ({ totalCount, onNewCategory, isDark }) => {
    return (
        <div className="d-flex justify-content-between align-items-center mb-3 flex-wrap gap-2">
            <div>
                <h5
                    className="fw-bold mb-1 d-flex align-items-center gap-2"
                    style={{ fontSize: '1.15rem', color: isDark ? '#f9fafd' : '#0f172a' }}
                >
                    <div
                        className="d-flex align-items-center justify-content-center rounded-circle"
                        style={{
                            width: '32px',
                            height: '32px',
                            backgroundColor: isDark ? 'rgba(37, 99, 235, 0.2)' : '#dbeafe',
                            color: isDark ? '#60a5fa' : '#2563eb'
                        }}
                    >
                        <FontAwesomeIcon icon={faRobot} style={{ fontSize: '0.9rem' }} />
                    </div>
                    <span>Mensajes Automáticos</span>
                    <span
                        className="badge rounded-pill ms-1"
                        style={{
                            fontSize: '0.72rem',
                            backgroundColor: isDark ? '#1e293b' : '#f1f5f9',
                            color: isDark ? '#94a3b8' : '#64748b',
                            border: `1px solid ${isDark ? '#334155' : '#e2e8f0'}`
                        }}
                    >
                        {totalCount}
                    </span>
                </h5>
                <p
                    className="small mb-0"
                    style={{ fontSize: '0.84rem', color: isDark ? '#94a3b8' : '#64748b' }}
                >
                    Configura las plantillas automáticas por categoría y asígnalas de forma general o por asesor.
                </p>
            </div>

            <div className="d-flex align-items-center gap-2">
                <button
                    type="button"
                    className="btn btn-sm btn-primary d-flex align-items-center gap-2 rounded-pill px-3 py-1.5 fw-semibold shadow-none"
                    onClick={onNewCategory}
                    style={{ fontSize: '0.84rem' }}
                >
                    <FontAwesomeIcon icon={faPlus} />
                    <span>Nueva Categoría</span>
                </button>
            </div>
        </div>
    );
};

export default AutomaticMessagesHeader;
